import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { AppStore } from '@app/app.store';
import { Observable } from 'rxjs';
import { Division, DivisionEditView, DivisionFormDto, DivisionsBySectionValue } from '../models/division.interface';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {
  constructor(protected appStore: AppStore, private http: HttpClient, private appConfigService: AppConfigService) {}

  /**
   * Change the status of divisions
   * @param divisions the divisions to change
   * @param active the status to assign
   */
  changeStatus(divisions: Division[], active: boolean) {
    let ids: string[] = [];
    divisions.forEach(division => {
      ids.push(division.id);
    });
    return this.http.post(`${this.appConfigService.getApi()}/divisions/active`, { active, ids });
  }

  create(divisions: Division[]): Observable<Division[]> {
    return this.http.post<Division[]>(`${this.appConfigService.getApi()}/divisions`, divisions);
  }

  update(id: string, division: Division): Observable<Division> {
    return this.http.put<Division>(`${this.appConfigService.getApi()}/divisions/${id}`, division);
  }

  getAll(includeInactive = false): Observable<Division[]> {
    let params = new HttpParams();
    params = params.append('includeInactive', includeInactive.toString());
    return this.http.get<Division[]>(`${this.appConfigService.getApi()}/divisions/all`, { params });
  }

  getVisible(all = false, includeInactive = false): Observable<Division[]> {
    return all ? this.getAll(includeInactive) : this.getOfLoggedUser();
  }

  getById(id: string) {
    return this.http.get<Division>(`${this.appConfigService.getApi()}/divisions/${id}`);
  }

  getOfLoggedUser(): Observable<Division[]> {
    return this.http.get<Division[]>(`${this.appConfigService.getApi()}/divisions/principal`);
  }

  getBySectionValue(): Observable<DivisionsBySectionValue> {
    return this.http.get<DivisionsBySectionValue>(`${this.appConfigService.getApi()}/divisions/sectionValue`);
  }

  save(divisions: DivisionFormDto[]): Observable<any> {
    return this.http.post<DivisionFormDto>(`${this.appConfigService.getApi()}/divisions?assign=true`, divisions);
  }

  edit(division: DivisionEditView): Observable<DivisionEditView> {
    return this.http.put<DivisionEditView>(`${this.appConfigService.getApi()}/divisions/${division.id}`, division);
  }

  sortedByDescription(divisions: Array<Division>): Array<Division> {
    return divisions.sort((div1, div2) => (div1.description > div2.description ? -1 : 1));
  }

  checkDivisionState(ids: string[], active: boolean): Observable<string[]> {
    let dto = { ids, active };
    return this.http.post<string[]>(`${this.appConfigService.getApi()}/division/check`, dto);
  }
}
